module.exports = __webpack_public_path__ + "img/jogo.938345dd.jpg";